import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=1f3a0c15&scoped=true&"
import script from "./Notificacao.vue?vue&type=script&lang=js&"
export * from "./Notificacao.vue?vue&type=script&lang=js&"
import style0 from "./Notificacao.vue?vue&type=style&index=0&id=1f3a0c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a0c15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabItem,VTabs,VTabsItems})
